import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
} from "react-bootstrap";
import { appConfig } from "../../../config";
import "./ChemistView.css";
var dateFormat = require("dateformat");

var moment = require("moment");
require("moment-duration-format");
class ChemistView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  convertTime = (timefetched) => {
    console.log(timefetched);
    let hours = Math.floor(timefetched / 60);
    console.log(hours);
    let AmOrPm = hours >= 12 ? "pm" : "am";
    let minutes = timefetched - hours * 60;
    minutes = minutes > 10 ? minutes : "0" + minutes;
    let finalTime;
    return (finalTime =
      hours > 12
        ? hours - 12 + ":" + minutes + " " + AmOrPm
        : hours + ":" + minutes + " " + AmOrPm);
  };

  render() {
    const data =
      this.props.ChemistuserDtls && this.props.ChemistuserDtls.item
        ? this.props.ChemistuserDtls && this.props.ChemistuserDtls.item
        : null;

    const datas = this.props.chemistmainDtls
      ? this.props.chemistmainDtls
      : null;

    console.log(this.props.chemistOfferDtls);
    /* const offerDetails = this.props.chemistOfferDtls
      ? this.props.chemistOfferDtls
      : null; */
    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            className="chemistmodeldiv"
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Profile Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <div className="storeNavdiv">
                  <Nav variant="pills">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Basic Info</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Contact Info</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Offers</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="fourth">More</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <Tab.Content style={{ border: "none" }}>
                  <Tab.Pane eventKey="first">
                    <div className="storeModalTbl">
                      <Table responsive bordered className="cmnMainTable">
                        <tbody>
                          <tr>
                            <td className="storeTdWdth">Organization Name</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.name}
                            </td>
                          </tr>
                          <tr>
                            <td>Category</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.category}
                            </td>
                          </tr>
                          <tr>
                            <td>Address1</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.addr1}
                            </td>
                          </tr>
                          <tr>
                            <td>Address2</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.addr2}
                            </td>
                          </tr>
                          <tr>
                            <td>Delivery </td>
                            <td className="storeModalCap">
                              {datas !== null &&
                              datas.homeDlry !== undefined &&
                              datas.homeDlry
                                ? "Home Delivery"
                                : "Store Pickup"}
                            </td>
                          </tr>

                          <tr>
                            <td> Country</td>
                            <td className="feedbkModalCap">
                              {datas !== null &&
                                datas.country !== undefined &&
                                datas.country.name}
                            </td>
                          </tr>
                          <tr>
                            <td> State</td>
                            <td className="feedbkModalCap">
                              {datas !== null &&
                                datas.state !== undefined &&
                                datas.state.name}
                            </td>
                          </tr>
                          <tr>
                            <td> Districts</td>
                            <td className="feedbkModalCap">
                              {datas !== null &&
                                datas.district !== undefined &&
                                datas.district.name}
                            </td>
                          </tr>
                          <tr>
                            <td>Landmark</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.landmark}
                            </td>
                          </tr>
                          <tr>
                            <td>City</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.city}
                            </td>
                          </tr>

                          <tr>
                            <td>Zip Code</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.zip}
                            </td>
                          </tr>
                          <tr>
                            <td>GST</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.gstin}
                            </td>
                          </tr>
                          <tr>
                            <td>Drug License(20B)</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.licenceNo}
                            </td>
                          </tr>
                          <tr>
                            <td>Drug License(21B)</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.drugLicense}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="second">
                    <div className="storeSecndModalTbl">
                      <Table responsive bordered className="cmnMainTable">
                        <tbody>
                          <tr>
                            <td>Contact Person</td>
                            <td className="storeModalCap">
                              {datas !== null && datas.contactPersn}
                            </td>
                          </tr>
                          <tr>
                            <td> Mobile Number</td>
                            <td className="storeModalCap">
                              {datas !== null &&
                                datas.userId !== undefined &&
                                datas.userId.mobileNo}
                            </td>
                          </tr>
                          {/* <tr>
                            <td>Org Name</td>
                            <td className="storeModalCap">
                              {datas !== null &&
                                datas.userId !== undefined &&
                                datas.userId.orgId}
                            </td>
                          </tr> */}

                          <tr>
                            <td>Email</td>
                            <td className="">
                              {" "}
                              {datas !== null && datas.email}
                            </td>
                          </tr>
                          <tr>
                            <td>Website</td>
                            <td className="">
                              {datas !== null && datas.website}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="third">
                    <div className="storeModalTbl">
                      {this.props.chemistOfferDtls &&
                        this.props.chemistOfferDtls !== null &&
                        this.props.chemistOfferDtls.map((offerDetails, i) => {
                          return (
                            <Table responsive bordered className="cmnMainTable" key={i}>
                              <tbody>
                                <tr>
                                  <td className="storeTdWdth">Sl No.</td>
                                  <td className="storeTdWdth">Offer</td>
                                  <td className="storeTdWdth">Details</td>
                                  <td className="storeTdWdth">Created Date</td>
                                  <td className="storeTdWdth">
                                    Current Status
                                  </td>
                                </tr>
                                <tr>
                                  <td className="storeModalCap">{i + 1}</td>
                                  <td className="storeModalCap">
                                    {offerDetails.title}
                                  </td>
                                  <td className="storeModalCap">
                                    {offerDetails.desc}
                                  </td>
                                  <td className="storeModalCap">
                                    {offerDetails !== null &&
                                      offerDetails.createdAt !== null &&
                                      dateFormat(
                                        offerDetails.createdAt,
                                        "mediumDate"
                                      )}
                                  </td>
                                  <td className="storeModalCap">
                                    {offerDetails.isActive === true
                                      ? "Active"
                                      : "Expired"}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          );
                        })}

                      {this.props.chemistOfferDtlsCount === 0 && (
                        <Table responsive bordered className="cmnMainTable">
                          <tbody>
                            <tr>
                              <td className="storeTdWdth">Offer</td>
                              <td className="storeTdWdth">Details</td>
                              <td className="storeTdWdth">Created Date</td>
                              <td className="storeTdWdth">Current Status</td>
                            </tr>
                            <tr>
                              <td colSpan={4} style={{ textAlign: "center" }}>
                                - No offers announced yet-
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      )}
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="fourth">
                    <div className="storeModalTbl">
                      <Table responsive bordered className="cmnMainTable">
                        <tbody>
                          <tr>
                            <td className="storeTdWdth">Mode of Operation</td>
                            <td className="storeModalCap">
                              {data !== null && data.oprMode
                                ? data.oprMode
                                : null}
                            </td>
                          </tr>

                          <tr>
                            <td>Working Hours</td>
                            <td>
                              <p>
                                Mon &nbsp;
                                {datas !== null &&
                                datas.workingHrs &&
                                datas.workingHrs.mon.open
                                  ? this.convertTime(
                                      datas.workingHrs.mon.open
                                    ) +
                                    " to " +
                                    this.convertTime(datas.workingHrs.mon.close)
                                  : "Holiday"}
                              </p>
                              <p>
                                Tue &nbsp;
                                {datas !== null &&
                                datas.workingHrs &&
                                datas.workingHrs.tue.open
                                  ? this.convertTime(
                                      datas.workingHrs.tue.open
                                    ) +
                                    " to " +
                                    this.convertTime(datas.workingHrs.tue.close)
                                  : "Holiday"}
                              </p>
                              <p>
                                Wed &nbsp;
                                {datas !== null &&
                                datas.workingHrs &&
                                datas.workingHrs.wed.open
                                  ? this.convertTime(
                                      datas.workingHrs.wed.open
                                    ) +
                                    " to " +
                                    this.convertTime(datas.workingHrs.wed.close)
                                  : "Holiday"}
                              </p>
                              <p>
                                Thu &nbsp;
                                {datas !== null &&
                                datas.workingHrs &&
                                datas.workingHrs.thu.open
                                  ? this.convertTime(
                                      datas.workingHrs.thu.open
                                    ) +
                                    " to " +
                                    this.convertTime(datas.workingHrs.thu.close)
                                  : "Holiday"}
                              </p>
                              <p>
                                Fri &nbsp;
                                {datas !== null &&
                                datas.workingHrs &&
                                datas.workingHrs.fri.open
                                  ? this.convertTime(
                                      datas.workingHrs.fri.open
                                    ) +
                                    " to " +
                                    this.convertTime(datas.workingHrs.fri.close)
                                  : "Holiday"}
                              </p>
                              <p>
                                Sat &nbsp;
                                {datas !== null &&
                                datas.workingHrs &&
                                datas.workingHrs.sat.open
                                  ? this.convertTime(
                                      datas.workingHrs.sat.open
                                    ) +
                                    " to " +
                                    this.convertTime(datas.workingHrs.sat.close)
                                  : "Holiday"}
                              </p>
                              <p>
                                Sun &nbsp;
                                {datas !== null &&
                                datas.workingHrs &&
                                datas.workingHrs.sun.open
                                  ? this.convertTime(
                                      datas.workingHrs.sun.open
                                    ) +
                                    " to " +
                                    this.convertTime(datas.workingHrs.sun.close)
                                  : "Holiday"}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>Logo</td>
                            <td className="storeModalCap">
                              <div className="storeImgDiv">
                                <Image
                                  className="storeImg"
                                  src={[
                                    datas && datas.imgUrl !== undefined
                                      ? appConfig.ip +
                                        "/attachments/preview/" +
                                        encodeURIComponent(datas.imgUrl)
                                      : require("../../../../src/assets/img/defaultPic.jpg"),
                                  ]}
                                />
                              </div>
                            </td>
                          </tr>


                          <tr>
                            <td className="storeTdWdth">Created Date</td>
                            <td className="storeModalCap">
                              {data !== null &&
                                data.createdAt !== null &&
                                dateFormat(data.createdAt, "mediumDate")}
                            </td>
                          </tr>

                          <tr>
                            <td className="storeTdWdth">Updated Date</td>
                            <td className="storeModalCap">
                              {data !== null &&
                                data.updatedAt !== null &&
                                dateFormat(data.updatedAt, "mediumDate")}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ChemistView;
